export default {
  // New betting tips messages following your existing pattern
  bettingTips: {
    en: 'Top Tips',
  },
  league: {
    en: 'League',
  },
  match: {
    en: 'Match',
  },
  tip: {
    en: 'Tip',
  },
  odds: {
    en: 'Odds',
  },
  date: {
    en: 'Date',
  },
  
  // Your original messages
  betslip: {
    en: 'Betslip',
  },
  myBets: {
    en: 'My bets',
  },
}
